import type { FC } from 'react';
import { DEFAULT_AI_STUDENT_NAME, DEFAULT_AI_STUDENT_DESCRIPTION } from '../config/aiStudent';

interface Props {
  isGroupRoom: boolean;
  name: string;
  description: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
}

const AiClassmateFields: FC<Props> = ({ isGroupRoom, name, description, onNameChange, onDescriptionChange }) => {
  if (!isGroupRoom) return null;
  const inputStyle = 'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white';
  return (
    <fieldset className="space-y-3 border border-gray-200 dark:border-gray-700 rounded-lg p-4">
      <legend className="px-1 text-sm font-medium text-gray-700 dark:text-gray-300">AI Classmate</legend>
      <p className="text-sm text-gray-500 dark:text-gray-400">A fellow student who shares ideas and thinks things through with the group.</p>
      <div>
        <label htmlFor="ai-student-name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Classmate name</label>
        <input id="ai-student-name" maxLength={60} value={name} onChange={e => onNameChange(e.target.value)} placeholder={DEFAULT_AI_STUDENT_NAME} className={inputStyle} />
      </div>
      <div>
        <label htmlFor="ai-student-description" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Personality description</label>
        <textarea id="ai-student-description" rows={3} maxLength={1000} value={description} onChange={e => onDescriptionChange(e.target.value)} placeholder={DEFAULT_AI_STUDENT_DESCRIPTION} className={inputStyle} />
      </div>
    </fieldset>
  );
};
export default AiClassmateFields;
